/* eslint-disable import/prefer-default-export */

export const apiSettings = {
  //baseUrl: 'http://localhost:3017/api/',
  //baseAssetsUrl: 'http://localhost:3017/',
  baseUrl: 'https://api.aid-link.com/api/',
  baseAssetsUrl: 'https://api.aid-link.com/',
  // baseUrl: process.env.REACT_APP_API_BASEURL,
  // baseAssetsUrl: process.env.REACT_APP_API_BASEURL,
  auth: {
    login: 'login',
    register: 'register',
    verifyPassword: 'verify-password',
    registerSupplier: 'register/supplier',
    me: 'me',
    roles: 'roles',
    forgotPassword: (email) => `forgot-password/${email}`,
    resetPassword: 'reset-password',
  },
  organization: {
    organizationTypes: 'organization-types',
  },
  companies: {
    getcompanyTypes: 'company-types',
  },
  bids: {
    saveBid: (id) => `bids/add-bid/${id}`,
    getLastSubmittedBid: (id) => `bids/tender/${id}`,
    getLastDraftBid: (id) => `bids/tender/draft/${id}`,
    getAllBidsByTenderId: (id) => `bids/get-all-bids-by-tender/${id}`,
    changeBidStatus: (id, status) =>
      `bids/change-status/${id}?status=${status}`,
    getDraftBids: (page = 1, searchText = '') =>
      `bids/draft?page=${page}${searchText ? '&search=' + searchText : ''}`,
    getSubmittedBids: (page = 1, searchText = '') =>
      `bids/submitted?page=${page}${searchText ? '&search=' + searchText : ''}`,
  },
  tender: {
    addTender: 'tender/add-tender',
    getLatLng: 'tender/latLng',
    awardTender: 'tender/award-tender',
    tenderAwardedTo: (id) => `tender/tender-awarded-to/${id}`,
    getTenders: (page) => `tender/all?page=${page}`,
    getSupplierAllTender: (
      page = 1,
      searchText,
      organization,
      publicationDateFrom,
      publicationDateTo,
      deadlieFrom,
      deadlieTo,
      procurementCategory,
      noticeType,
      location
    ) =>
      `tender/supplier/all?page=${page}${
        searchText ? '&search=' + searchText : ''
      }${organization ? '&organization=' + organization : ''}${
        publicationDateFrom ? '&publicationDateFrom=' + publicationDateFrom : ''
      }${publicationDateTo ? '&publicationDateTo=' + publicationDateTo : ''}${
        deadlieFrom ? '&deadlieFrom=' + deadlieFrom : ''
      }${deadlieTo ? '&deadlieTo=' + deadlieTo : ''}${
        procurementCategory ? '&procurementCategory=' + procurementCategory : ''
      }${noticeType ? '&noticeType=' + noticeType : ''}${
        location ? '&location=' + location : ''
      }`,
    getMyTenders: (page) => `tender/my?page=${page}`,
    editTender: (id) => `tender/edit/${id}`,
    openDownloadBidForTender: (id) =>
      `tender/open-download-bid-for-tender/${id}`,
    getTenderById: (id) => `tender/${id}`,
    getTenderDetailById: (id) => `tender/detail/${id}`,
    deleteTenderById: (id) => `tender/delete/${id}`,
    deleteTenderFile: (id, path) => `tender/delete/${id}/${path}`,
    getTenderChangeHistory: (id) => `tender/logs/${id}`,
  },
  users: {
    getOrganizationUser: 'users/get-users',
  },
  notifications: {
    getMyNotifications: 'notifications/my-notification',
    notificationMarkAsRead: (id) => `notifications/mark-as-read/${id}`,
  },
  message: {
    sendMessage: () => `message/send`,
    getChatFor: `message/get-chat-for`,
    getChatHeads: () => `message/get-chat-heads`,
    getAllMessagesByTenderId: (id) => `message/get-messages-by-tender/${id}`,
  },

  chats: {
    sendChat: () => `chats/send`,
    getChatsList: (page = 1) => `chats/get-chats-list-buyer?page=${page}`,
    getChatsDetail: (id) => `chats/get-chats-detail/${id}`,
    getChatsByTender: (id) => `chats/get-chats-by-tender/${id}`,
  },
};
